import Yup from "../../../../YupValidation";

// eslint-disable-next-line import/prefer-default-export
export const debtor = Yup.object().shape({});
